<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <h1>{{ dialogSettings.title }}</h1>
        <ApplicationQuestionTemplateForm
          ref="formTemplate"
          @onSubmit="createTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="validateForm" :loading="isAdding">
        Create Question
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ORGANISATION_APPLICATION_QUESTION_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-application-question-templates";
import { CREATE_APPLICATION_QUESTION_TEMPLATE } from "@/store/modules/organisations/organisation-application-question-templates/actions";
import ApplicationQuestionTemplateForm from "../ApplicationQuestionTemplateForm";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { GET_CURRENT_ORGANISATION_ID } from "@/store/modules/auth/getters";

const { mapGetters: mapAuthGetters } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapActions } = createNamespacedHelpers(
  ORGANISATION_APPLICATION_QUESTION_TEMPLATES_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean
  },
  components: {
    PrimaryButton,
    DialogFull,
    ApplicationQuestionTemplateForm
  },
  data() {
    return {
      isAdding: false
    };
  },
  computed: {
    ...mapAuthGetters({
      userOrganisationId: GET_CURRENT_ORGANISATION_ID
    }),
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "New Application Question"
      };
    }
  },
  methods: {
    ...mapActions({
      createApplicationQuestionTemplate: CREATE_APPLICATION_QUESTION_TEMPLATE
    }),
    validateForm() {
      this.$refs.formTemplate.validateForm();
    },
    async createTemplate(templateData) {
      this.isAdding = true;
      await this.createApplicationQuestionTemplate({
        ...templateData,
        organisation: {
          id: this.userOrganisationId
        }
      });
      this.close();
      this.isAdding = false;
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
